import { isStandalone } from '@/utils/platform/isStandalone';

// eslint-disable-next-line no-console
console.log('Gen Ai Studio Logs', {
  isStandalone: isStandalone(),
  version: import.meta.env.VITE_APP_VERSION,
});
